let rootStyles = localStorage.getItem('rootStyles');
let brandHeader = JSON.parse(localStorage.getItem('brandHeader'));
let brandFooter = localStorage.getItem('brandFooter');
if (rootStyles) {
    var styleElement = document.createElement('style');
    styleElement.textContent = rootStyles;
    document.head.replaceChild(styleElement, document.querySelector("#root-styles"));
}
if(brandHeader){
  document.querySelectorAll('.shopify-section-group-header-group').forEach((section, index)=>{
    section.innerHTML = brandHeader[index];
  });
}
document.addEventListener("DOMContentLoaded", () => {
  if(brandFooter){
    document.querySelector('footer.footer').innerHTML = brandFooter;
  }
});
